module.exports = __webpack_public_path__ + "static/neo-search-f86ef3efcd9ad4818e266cb255e55a2d.png";